import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { Toaster } from "./components/ui/sonner";
import { Navbar } from "./components/Navbar";
import { WhatsAppFloat } from "./components/WhatsAppFloat";
import Home from "./pages/Home";
import Games from "./pages/Games";
import GameDetail from "./pages/GameDetail";
import Branches from "./pages/Branches";
import BranchDetail from "./pages/BranchDetail";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminGames from "./pages/admin/AdminGames";
import AdminBranches from "./pages/admin/AdminBranches";
import AdminReservations from "./pages/admin/AdminReservations";
import AdminBranchReservations from "./pages/admin/AdminBranchReservations";
import AdminBanners from "./pages/admin/AdminBanners";
import "./App.css";

console.log('🎮 Phobia Games App Loading...');
console.log('📍 Current URL:', window.location.href);
console.log('🌐 Environment:', process.env.NODE_ENV);

function App() {
  console.log('✅ App Component Rendering');
  
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="min-h-screen bg-[#050000]">
          <div className="noise-overlay" />
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/games" element={<Games />} />
            <Route path="/games/:id" element={<GameDetail />} />
            <Route path="/branches" element={<Branches />} />
            <Route path="/branches/:id" element={<BranchDetail />} />
            <Route path="/cinema" element={<Games />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/admin/games" element={<AdminGames />} />
            <Route path="/admin/branches" element={<AdminBranches />} />
            <Route path="/admin/reservations" element={<AdminReservations />} />
            <Route path="/admin/reservations/:branchId" element={<AdminBranchReservations />} />
            <Route path="/admin/banners" element={<AdminBanners />} />
          </Routes>
          <WhatsAppFloat />
          <Toaster 
            position="top-right" 
            toastOptions={{
              style: {
                background: '#0F0F0F',
                color: '#EDEDED',
                border: '1px solid #333'
              }
            }}
          />
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
